/// *** System import ***///
import { Component, ViewChild } from '@angular/core';
import { Content, NavController, PopoverController, ToastController, AlertController, Alert } from 'ionic-angular';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../../app/globals';
import { SessionProvider } from '../../../providers/session';
import { TradingProcessProvider } from '../../../providers/processes/trading';
import { Trading_OrderBookStore } from './orderBook.store';
import { Trading_OrderPage } from '../order/order';

@Component({
  selector: 'page-trading-orderBook',
  templateUrl: 'orderBook.html',
})
export class Trading_OrderBookPage {
  @ViewChild(Content) private content: Content;
  private isBuzy = true;
  private isProcessing = false;
  constructor(
    // *** System
    private navCtrl: NavController,
    private popoverCtrl: PopoverController,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    // *** Custom
    private globals: Globals,
    private session: SessionProvider,
    private tradingProcess: TradingProcessProvider,
    private store: Trading_OrderBookStore) {
    this.store.configParams(
      {
        showSearch: false,
      }, false);
  }

  // *** Evénement de chargement
  ngOnInit() {
    try {
      this.isBuzy = true;
      this.store.loadParams().then(
        (succeed) => {
          this.store.load().then(
            (succeed) => {
              this.isBuzy = false;
              this.content.resize();
            },
            (error) => { this.isBuzy = false; }
          );
        },
        (error) => { this.isBuzy = false; }
      );
    }
    catch (error) {
      this.isBuzy = false;
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Evénement de clôture
  ionViewWillUnload() {
    try {
      this.store.reset();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Afficher/Cacher la barre de recherche
  private _toggleSearch() {
    try {
      this.store.params.showSearch = !this.store.params.showSearch;
      if (!this.store.params.showSearch)
        this.store.search(null);
      this.content.resize();
      this.store.persistParams();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Recherche dans la liste des instruments
  private _doSearch(ev) {
    try {
      this.store.search(ev);
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Recharger les données
  private _doRefresh(refresher) {
    try {
      this.isBuzy = true;
      this.store.load(true).then(
        (result) => {
          refresher.complete();
          this.content.resize();
          this.content.scrollToTop();
          this.isBuzy = false;
        },
        (error) => {
          refresher.complete();
          this.isBuzy = false;
        }
      );
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      refresher.complete();
      this.isBuzy = false;
    }
  }

  // *** Afficher/Cacher les détails
  private _toggleDetails(order: any) {
    try {
      order.ShowDetails = !order.ShowDetails;
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Afficher la fenêtre de l'ordre pour modification
  private _presentOrder(order: any) {
    try {
      this.isProcessing = true;
      let params = {
        isNew: false,
        orderID: order.TradingOrderID
      }
      this.navCtrl.push(Trading_OrderPage, params);
      this.isProcessing = false;
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.isProcessing = false;
    }
  }

  // *** Annuler un ordre
  private _cancelOrder(order: any) {
    try {
      let alert = this.alertCtrl.create({
        title: order.Wording,
        message: this.globals.MSG_ORDER_CANCEL_CONFIRM,
        buttons: [
          {
            text: 'Non',
            role: 'cancel',
            handler: () => { }
          },
          {
            text: 'Confirmer',
            handler: () => {
              this.isProcessing = true;
              //*** ToDo */
              this.tradingProcess.cancelOrder(order.TradingOrderID).then(
                (result) => { this.isProcessing = false; },
                (error) => { this.isProcessing = false; }
              );
            }
          }
        ]
      });
      alert.present();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.isProcessing = false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/trading/orderBook/orderBook.ts